// ============================================
// Chat Module - Recommended Questions (ES6)
// 추천 질문 패널 관리
// ============================================

import { sendMessage } from './send.js';
import { showToast } from '../utils.js';
import { ModalManager } from '../modal-manager.js';

// ============================================
// State
// ============================================

let isOpen = false;

// ============================================
// 시진 옵션 (사주용)
// ============================================
const BIRTH_TIME_OPTIONS = [
  { value: '모름', label: '모름' },
  { value: '자시', label: '자시 (23:00~01:00)' },
  { value: '축시', label: '축시 (01:00~03:00)' },
  { value: '인시', label: '인시 (03:00~05:00)' },
  { value: '묘시', label: '묘시 (05:00~07:00)' },
  { value: '진시', label: '진시 (07:00~09:00)' },
  { value: '사시', label: '사시 (09:00~11:00)' },
  { value: '오시', label: '오시 (11:00~13:00)' },
  { value: '미시', label: '미시 (13:00~15:00)' },
  { value: '신시', label: '신시 (15:00~17:00)' },
  { value: '유시', label: '유시 (17:00~19:00)' },
  { value: '술시', label: '술시 (19:00~21:00)' },
  { value: '해시', label: '해시 (21:00~23:00)' }
];

function getBirthTimeOptions(selectedValue = '모름') {
  return BIRTH_TIME_OPTIONS.map(opt =>
    `<option value="${opt.value}" ${opt.value === selectedValue ? 'selected' : ''}>${opt.label}</option>`
  ).join('');
}

// ============================================
// Toggle Panel
// ============================================

export function toggleRecommendedQuestions() {
  const panel = document.getElementById('recommendedQuestionsPanel');
  const btn = document.getElementById('recommendedQuestionsBtn');

  if (!panel || !btn) return;

  isOpen = !isOpen;

  if (isOpen) {
    panel.style.display = 'block';
    btn.classList.add('active');
  } else {
    panel.style.display = 'none';
    btn.classList.remove('active');
  }
}

export function closeRecommendedQuestions() {
  const panel = document.getElementById('recommendedQuestionsPanel');
  const btn = document.getElementById('recommendedQuestionsBtn');

  if (panel) panel.style.display = 'none';
  if (btn) btn.classList.remove('active');
  isOpen = false;
}

// ============================================
// Select Question
// ============================================

export function selectRecommendedQuestion(question) {
  const input = document.getElementById('messageInput');
  if (input) {
    input.value = question;
  }
  closeRecommendedQuestions();

  // Auto-send the message
  sendMessage();
}

// ============================================
// Compatibility Modal (궁합)
// ============================================

function createCompatibilityModalHTML() {
  const container = document.createElement('div');
  container.className = 'bottom-sheet-overlay';
  container.id = 'compatibilityModal';

  const backdrop = document.createElement('div');
  backdrop.className = 'bottom-sheet-backdrop';
  backdrop.dataset.action = 'close';

  const sheet = document.createElement('div');
  sheet.className = 'bottom-sheet';
  sheet.style.maxHeight = '70vh';

  const handle = document.createElement('div');
  handle.className = 'bottom-sheet-handle';

  const header = document.createElement('div');
  header.className = 'bottom-sheet-header';
  const headerTitle = document.createElement('h3');
  headerTitle.textContent = '💕 궁합 보기';
  header.appendChild(headerTitle);

  const body = document.createElement('div');
  body.className = 'bottom-sheet-body';

  // 설명 텍스트
  const desc = document.createElement('p');
  desc.style.cssText = 'color: var(--text-secondary); font-size: 13px; margin-bottom: 16px;';
  desc.textContent = '궁합을 볼 상대방의 정보를 입력해주세요';
  body.appendChild(desc);

  // 이름 입력
  const nameGroup = document.createElement('div');
  nameGroup.className = 'form-group';
  const nameLabel = document.createElement('label');
  nameLabel.textContent = '이름';
  const nameInput = document.createElement('input');
  nameInput.type = 'text';
  nameInput.id = 'compatibilityNameInput';
  nameInput.placeholder = '상대방 이름';
  nameGroup.appendChild(nameLabel);
  nameGroup.appendChild(nameInput);
  body.appendChild(nameGroup);

  // 성별 선택
  const genderGroup = document.createElement('div');
  genderGroup.className = 'form-group';
  const genderLabel = document.createElement('label');
  genderLabel.textContent = '성별';
  const genderSelector = document.createElement('div');
  genderSelector.className = 'gender-selector-clean';

  const maleBtn = document.createElement('button');
  maleBtn.type = 'button';
  maleBtn.className = 'gender-btn-clean selected';
  maleBtn.dataset.gender = '남성';
  maleBtn.dataset.action = 'selectGender';
  maleBtn.textContent = '남성';

  const femaleBtn = document.createElement('button');
  femaleBtn.type = 'button';
  femaleBtn.className = 'gender-btn-clean';
  femaleBtn.dataset.gender = '여성';
  femaleBtn.dataset.action = 'selectGender';
  femaleBtn.textContent = '여성';

  genderSelector.appendChild(maleBtn);
  genderSelector.appendChild(femaleBtn);

  const genderHidden = document.createElement('input');
  genderHidden.type = 'hidden';
  genderHidden.id = 'compatibilityGenderInput';
  genderHidden.value = '남성';

  genderGroup.appendChild(genderLabel);
  genderGroup.appendChild(genderSelector);
  genderGroup.appendChild(genderHidden);
  body.appendChild(genderGroup);

  // 생년월일 + 시간
  const birthGroup = document.createElement('div');
  birthGroup.className = 'form-group';
  const birthLabel = document.createElement('label');
  birthLabel.textContent = '생년월일';

  const birthRow = document.createElement('div');
  birthRow.style.cssText = 'display: flex; gap: 10px; align-items: center;';

  const dateInput = document.createElement('input');
  dateInput.type = 'date';
  dateInput.id = 'compatibilityBirthDateInput';
  dateInput.style.flex = '1';

  const timeSelect = document.createElement('select');
  timeSelect.id = 'compatibilityBirthTimeInput';
  timeSelect.className = 'form-select';
  timeSelect.style.flex = '1';
  timeSelect.innerHTML = getBirthTimeOptions();

  birthRow.appendChild(dateInput);
  birthRow.appendChild(timeSelect);
  birthGroup.appendChild(birthLabel);
  birthGroup.appendChild(birthRow);
  body.appendChild(birthGroup);

  // 음력/양력 선택
  const calendarGroup = document.createElement('div');
  calendarGroup.className = 'form-group';
  const calendarLabel = document.createElement('label');
  calendarLabel.textContent = '음력/양력';
  const calendarSelector = document.createElement('div');
  calendarSelector.className = 'gender-selector-clean';

  const solarBtn = document.createElement('button');
  solarBtn.type = 'button';
  solarBtn.className = 'gender-btn-clean selected';
  solarBtn.dataset.calendar = '양력';
  solarBtn.dataset.action = 'selectCalendar';
  solarBtn.textContent = '양력';

  const lunarBtn = document.createElement('button');
  lunarBtn.type = 'button';
  lunarBtn.className = 'gender-btn-clean';
  lunarBtn.dataset.calendar = '음력';
  lunarBtn.dataset.action = 'selectCalendar';
  lunarBtn.textContent = '음력';

  calendarSelector.appendChild(solarBtn);
  calendarSelector.appendChild(lunarBtn);

  const calendarHidden = document.createElement('input');
  calendarHidden.type = 'hidden';
  calendarHidden.id = 'compatibilityCalendarInput';
  calendarHidden.value = '양력';

  calendarGroup.appendChild(calendarLabel);
  calendarGroup.appendChild(calendarSelector);
  calendarGroup.appendChild(calendarHidden);
  body.appendChild(calendarGroup);

  // 버튼 영역
  const btnRow = document.createElement('div');
  btnRow.style.cssText = 'display: flex; gap: 10px; margin-top: 20px;';

  const cancelBtn = document.createElement('button');
  cancelBtn.className = 'btn btn-secondary';
  cancelBtn.dataset.action = 'close';
  cancelBtn.style.flex = '1';
  cancelBtn.textContent = '취소';

  const submitBtn = document.createElement('button');
  submitBtn.className = 'btn btn-primary';
  submitBtn.dataset.action = 'submit';
  submitBtn.style.flex = '1';
  submitBtn.textContent = '궁합 보기';

  btnRow.appendChild(cancelBtn);
  btnRow.appendChild(submitBtn);
  body.appendChild(btnRow);

  sheet.appendChild(handle);
  sheet.appendChild(header);
  sheet.appendChild(body);
  container.appendChild(backdrop);
  container.appendChild(sheet);

  return container;
}

export function openCompatibilityModal() {
  closeRecommendedQuestions();

  const modal = createCompatibilityModalHTML();

  // 이벤트 위임 설정
  modal.addEventListener('click', (e) => {
    const actionEl = e.target.closest('[data-action]');
    if (!actionEl) return;

    const action = actionEl.dataset.action;
    if (action === 'close') {
      closeCompatibilityModal();
    } else if (action === 'submit') {
      submitCompatibility();
    } else if (action === 'selectGender') {
      const container = actionEl.closest('.gender-selector-clean');
      container.querySelectorAll('.gender-btn-clean').forEach(b => b.classList.remove('selected'));
      actionEl.classList.add('selected');
      document.getElementById('compatibilityGenderInput').value = actionEl.dataset.gender;
    } else if (action === 'selectCalendar') {
      const container = actionEl.closest('.gender-selector-clean');
      container.querySelectorAll('.gender-btn-clean').forEach(b => b.classList.remove('selected'));
      actionEl.classList.add('selected');
      document.getElementById('compatibilityCalendarInput').value = actionEl.dataset.calendar;
    }
  });

  document.body.appendChild(modal);

  requestAnimationFrame(() => {
    modal.classList.add('open');
    if (window.ModalManager) {
      window.ModalManager.register('compatibilityModal', closeCompatibilityModal, 'bottomSheet');
      window.ModalManager.push('compatibilityModal');
    }
  });
}

export function closeCompatibilityModal() {
  const modal = document.getElementById('compatibilityModal');
  if (!modal) return;

  ModalManager.remove('compatibilityModal', true);
  modal.classList.remove('open');

  setTimeout(() => {
    if (modal.parentNode) {
      modal.remove();
    }
    ModalManager.unregister('compatibilityModal');
  }, 350);
}

function submitCompatibility() {
  const name = document.getElementById('compatibilityNameInput').value.trim();
  const gender = document.getElementById('compatibilityGenderInput').value;
  const birthDate = document.getElementById('compatibilityBirthDateInput').value;
  const birthTime = document.getElementById('compatibilityBirthTimeInput').value;
  const birthCalendar = document.getElementById('compatibilityCalendarInput').value;

  if (!name) {
    showToast('상대방 이름을 입력해주세요', 'error');
    return;
  }

  if (!birthDate) {
    showToast('상대방 생년월일을 입력해주세요', 'error');
    return;
  }

  closeCompatibilityModal();

  // 궁합 상대 정보 객체 (서버에서 사주 계산용)
  const compatibility = {
    name,
    gender,
    birthDate,
    birthTime,
    birthCalendar
  };

  // 궁합 요청 메시지
  const message = `${name}님과의 궁합을 봐주세요. 전체적인 궁합 점수, 잘 맞는 부분과 주의할 부분, 함께 발전하기 위한 조언을 알려주세요.`;

  // 메시지 입력 후 전송 (compatibility 정보 포함)
  const input = document.getElementById('messageInput');
  if (input) {
    input.value = message;
  }
  sendMessage(null, { compatibility });
}

// ============================================
// Initialize Events
// ============================================

export function initRecommendedQuestions() {
  // Toggle button
  const toggleBtn = document.getElementById('recommendedQuestionsBtn');
  if (toggleBtn) {
    toggleBtn.addEventListener('click', toggleRecommendedQuestions);
  }

  // Question chips (event delegation)
  const panel = document.getElementById('recommendedQuestionsPanel');
  if (panel) {
    panel.addEventListener('click', (e) => {
      const chip = e.target.closest('.question-chip');
      if (!chip) return;

      // 궁합 버튼 처리
      if (chip.dataset.action === 'openCompatibility') {
        openCompatibilityModal();
        return;
      }

      // 일반 질문 처리
      if (chip.dataset.question) {
        selectRecommendedQuestion(chip.dataset.question);
      }
    });
  }

  // Close when clicking outside
  document.addEventListener('click', (e) => {
    if (!isOpen) return;

    const panel = document.getElementById('recommendedQuestionsPanel');
    const btn = document.getElementById('recommendedQuestionsBtn');

    if (!panel?.contains(e.target) && !btn?.contains(e.target)) {
      closeRecommendedQuestions();
    }
  });

  console.log('[RecommendedQuestions] 초기화 완료');
}
